module.exports = __webpack_public_path__ + "static/media/palco_azteca.9be6deb9.jpg";